(function () {
  document.querySelectorAll(".user-voice [data-carousel]").forEach((root) => {
    const carousel = root.querySelector(".carousel");
    const items = root.querySelectorAll(".product-container");
    const prevBtn = root.querySelector(".left-arrow");
    const nextBtn = root.querySelector(".right-arrow");

    if (!carousel || items.length === 0) return;

    const perViewPc = Number(root.dataset.carouselPc) || 3;
    const perViewSp = Number(root.dataset.carouselSp) || 1;

    let currentIndex = 0;
    let startX = 0;
    let isDragging = false;

    function isMobile() {
      return window.matchMedia("(max-width: 767px)").matches;
    }

    function getPerView() {
      return isMobile() ? perViewSp : perViewPc;
    }

    function getMaxIndex() {
      return Math.max(0, items.length - getPerView());
    }

    function updateCarousel(animate) {
      const perView = getPerView();
      const slideWidth = 100 / perView;

      if (animate === false) {
        carousel.style.transition = "none";
      } else {
        carousel.style.transition = "transform 0.5s ease-in-out";
      }

      carousel.style.transform = `translateX(-${currentIndex * slideWidth}%)`;
    }

    function goTo(index) {
      const maxIndex = getMaxIndex();
      currentIndex = Math.min(Math.max(index, 0), maxIndex);
      updateCarousel();
    }

    prevBtn?.addEventListener("click", () => goTo(currentIndex - 1));
    nextBtn?.addEventListener("click", () => goTo(currentIndex + 1));

    carousel.addEventListener(
      "touchstart",
      (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
      },
      { passive: true }
    );

    carousel.addEventListener(
      "touchmove",
      (e) => {
        if (!isDragging) return;

        const perView = getPerView();
        const slideWidth = 100 / perView;
        const deltaX = e.touches[0].clientX - startX;
        carousel.style.transition = "none";
        const offset = -currentIndex * slideWidth + (deltaX / root.offsetWidth) * 100;
        carousel.style.transform = `translateX(${offset}%)`;
      },
      { passive: true }
    );

    carousel.addEventListener(
      "touchend",
      (e) => {
        if (!isDragging) return;
        isDragging = false;
        const deltaX = e.changedTouches[0].clientX - startX;

        if (deltaX > 50) {
          goTo(currentIndex - 1);
        } else if (deltaX < -50) {
          goTo(currentIndex + 1);
        } else {
          updateCarousel();
        }
      },
      { passive: true }
    );

    window.addEventListener("resize", () => {
      goTo(Math.min(currentIndex, getMaxIndex()));
      updateCarousel(false);
    });

    goTo(0);
    updateCarousel(false);
  });
})();
